export class ModalButtonBuilder {
    constructor() {
        this._buttons = [];
    }

    add(id, textOrFnOrOpts = null, arg3 = null, arg4 = null) {
        if (!id) {
            throw new Error('[ModalButtonBuilder] "id" parameter is required as the first argument to add().');
        }

        let text = typeof textOrFnOrOpts === 'string' ? textOrFnOrOpts : id;
        let btnClass = 'gm-btn-secondary';
        let onClick = null;
        let opts = {};

        let actualArg3 = arg3;
        let actualArg4 = arg4;

        if (typeof textOrFnOrOpts === 'function') {
            onClick = textOrFnOrOpts;
        } else if (typeof textOrFnOrOpts === 'object' && textOrFnOrOpts !== null) {
            opts = textOrFnOrOpts;
        }

        if (typeof actualArg3 === 'function') {
            onClick = actualArg3;
            if (typeof actualArg4 === 'object' && actualArg4 !== null) opts = actualArg4;
            else if (typeof actualArg4 === 'string') btnClass = actualArg4;
        } else if (typeof actualArg3 === 'string') {
            btnClass = actualArg3;
            if (typeof actualArg4 === 'function') onClick = actualArg4;
            else if (typeof actualArg4 === 'object' && actualArg4 !== null) opts = actualArg4;
        } else if (typeof actualArg3 === 'object' && actualArg3 !== null) {
            opts = actualArg3;
        }

        const btn = {
            id,
            text,
            class: opts.class || btnClass,
            onClick: onClick || opts.onClick || null,
            close: opts.close !== undefined ? opts.close : true,
            title: opts.title || null,
            icon: opts.icon || null,
            color: opts.color || null,
            textColor: opts.textColor || null,
            showIf: opts.showIf || null
        };
        this._buttons.push(btn);
        return this._wrap(btn);
    }

    accept(text = 'OK') {
        return this.add('btnAccept', text).withClass('gm-btn-primary').close(true);
    }

    cancel(text = 'CANCEL') {
        return this.add('btnCancel', text).withClass('gm-btn-secondary').close(true);
    }

    _wrap(btn) {
        const self = this;
        return {
            withText: (t) => { btn.text = t; return self._wrap(btn); },
            withTitle: (t) => { btn.title = t; return self._wrap(btn); },
            withIcon: (i) => { btn.icon = i; return self._wrap(btn); },
            withClass: (c) => { btn.class = c; return self._wrap(btn); },
            withBackgroundColor: (c) => { btn.color = c; return self._wrap(btn); },
            withTextColor: (c) => { btn.textColor = c; return self._wrap(btn); },
            onClick: (fn) => { btn.onClick = fn; return self._wrap(btn); },
            showIf: (conditionFn) => { btn.showIf = conditionFn; return self._wrap(btn); },
            close: (val = true) => { btn.close = val; return self._wrap(btn); },
            withFluid: () => {
                btn.class = (btn.class || '') + ' gm-btn-fluid';
                return self._wrap(btn);
            }
        };
    }

    _getButtons() {
        return this._buttons;
    }
}
